
export default function VideoTestimonal(){
    return (
        <section className="video_test my-4">
            <div className="bg-black rounded-2xl py-10 text-white flex flex-col items-center justify-center px-6 lg:px-0">
            <h1 className="max-w-2xl lg:max-w-lg text-3xl lg:text-5xl pt-4 lg:pt-6 text-center tracking-normal font-medium">
             This is what <span className="font-serif italic text-primary-light-7 font-semibold">Growth</span> looks like.</h1>
            <p className="lg:max-w-xl text-center pt-2 pb-4 lg:pt-6 lg:pb-6 text-light-grey-1 text-sm md:text-lg font-medium ">Step inside our world, where women dream, build, pitch,  grow together and thriving through Shecluded’s programs and community.</p>
          
              {/* <div className="video-embed-container"> */}
              {/* <video src={"https://shecluded-medias.s3.us-east-2.amazonaws.com/testimonial_video.mp4"} controls className="w-auto h-[300px] lg:h-[400px]"></video> */}
              {/* </div> */}

              <div className="img-container-comm  w-full lg:w-3/4 h-[200px] p-[5px] lg:h-[480px] bg-gradient-to-r from-[#101010] via-[#EB2590] to-[#101010] rounded-2xl lg:rounded-3xl">
                   <div className="w-full h-full rounded-2xl lg:rounded-3xl"
                   style={{
                            backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 100%, rgba(0, 0, 0, 0.9) 100%), url('https://shecluded-medias.s3.us-east-2.amazonaws.com/comm-women.png')`
                        }}> 
                    
                </div>
                {/* <img src="https://shecluded-medias.s3.us-east-2.amazonaws.com/comm-women.png" alt="women of shecluded communtiy smiling" className="w-full  p-1 h-[200px] lg:h-[450px] object-cover rounded-2xl lg:rounded-3xl "></img> */}
              </div>
              
            </div>
      
        </section>
    )
}

